import React from "react";
import { Link } from "react-router-dom";
import { store } from "../../Redux/store";
import { getAllAccountDetails } from "../../Services/Index";
import Swal from "sweetalert2";
import Loading from "../Animation/Loading/Loading";
import styled from "styled-components";
import moment from "moment";
import {
  _InfinityStackingsContract,
  _INFP_Stack_btn,
  _PayoutContract,
  web3_,
  _StackPayoutContract,
} from "../../Services/Web3Connection";
import { _INFP_Unstack_btn } from "../../Services/Web3Connection";
import { _INFP_Reward } from "../../Services/Web3Connection";
import { InfinityStackingAddress } from "../../config/constants/Contracts";
import { PayoutContractAddress } from "../../config/constants/Contracts";
import DialogComponent from "../DialogComponent";
import DialogComponetStack from "../DialogComponetStack";

export default function StakeCards(props) {
  const [StackContract, setStackContract] = React.useState(null);
  const [isApproveDisabled, setisApproveDisabled] = React.useState(true);
  const [isStackDisabled, setisStackDisabled] = React.useState(true);
  const [isInputDisabled, setisInputDisabled] = React.useState(false);
  const [isValue, setValue] = React.useState(0);
  const [APY, setAPY] = React.useState(0);
  const [totalStkd, setTotalStkd] = React.useState(0);
  const [stackBalance, setStackBalance] = React.useState(0);
  const [stackRewardBalance, setStackRewardBalance] = React.useState(0);
  const [StackTotalBalance, setStackTotalBalance] = React.useState(0);
  const [StackTotalReward, setTotalStacked] = React.useState(0);
  const [isloading, setIsLoading] = React.useState(false);
  const [MaturityTime, setMaturityTime] = React.useState(0);
  const [CoolingTime, setCoolingTime] = React.useState(0);
  const [StakeUserDetail, setStakeUserDetail] = React.useState(0);
  const [StackCounter, setStackCounter] = React.useState(0);
  const [options, setTheArray] = React.useState([]);
  const [CheckConnection, setCheckConnection] = React.useState(props.Connect);
  const [isStackPayoutTokenContracted, setisStackPayoutTokenContracted] =
    React.useState([]);
  React.useEffect(async () => {
    let stackContract = await _InfinityStackingsContract();
    setStackContract(stackContract);
    // console.log(stackContract.methods);
    setisStackPayoutTokenContracted(await _StackPayoutContract());

    // stackContract.methods
    //   .poolRewardPercent()
    //   .call()
    //   .then((res) => setAPY(res));
    setMaturityTime(await stackContract.methods.fullMaturityTime().call());
    // setCoolingTime(await stackContract.methods.coolingPeriod().call());
    // setStakeUserDetail(
    //   await stackContract.methods
    //     .users(store.getState().ConnectivityReducer.metamaskAddress)
    //     .call()
    // );
  }, []);

  React.useEffect(async () => {
    let stackContract = await _InfinityStackingsContract();
    if (props.Connect) {
      _HandleConnect();

      stackContract.methods
        .userTotalStake(store.getState().ConnectivityReducer.metamaskAddress)
        .call()
        .then((res) => {
          console.log(res);
          setStackTotalBalance(res / Math.pow(10, 18));
          setisApproveDisabled(true);
          setisStackDisabled(true);
          setisInputDisabled(false);
          setValue(0);
        });

      stackContract.methods
        .stakeIndex(store.getState().ConnectivityReducer.metamaskAddress)
        .call()
        .then(async (res) => {
          setTotalStacked(res);
          console.log(res, "calaim round");
          var data = 0;
          // for (let index = 1; index <= res; index++) {
          //   data =
          //     data +
          //     (await totalRewards(index, stackContract)) / Math.pow(10, 18);
          //   // parseFloat(totalRewards(index, stackContract)) ;
          // }
          // console.log(data);
          setStackRewardBalance(data);
          setIsLoading(false);
        });
    } else {
      console.log("Please connect to Metamask and try again");
    }
  }, [props.Connect]);

  async function totalRewards(index, stackContract) {
    let userClaim = await stackContract.methods
      .users(store.getState().ConnectivityReducer.metamaskAddress, index)
      .call();
    console.log(userClaim);
    if (!userClaim.isRewardClaimed) {
      let data = await stackContract.methods
        .rewardsCalculate(
          store.getState().ConnectivityReducer.metamaskAddress,
          index
        )
        .call();
      console.log(data);
      return parseFloat(data);
    } else {
      return 0;
    }
  }
  // console.log(StakeUserDetail);
  const ValidationDates = {
    CurrentDate: parseInt(new Date().getTime() / 1000),
    DepositeTime: parseInt(StakeUserDetail[1]),
    Cooling: parseInt(CoolingTime),
    Maturity: Math.floor(MaturityTime / (3600 * 24)) * 86400,
  };

  async function handleClaim() {
    if (
      props.Connect &&
      ValidationDates.CurrentDate <
        ValidationDates.DepositeTime + ValidationDates.Maturity
    ) {
      Swal.fire("Maturity Time not reached", "", "warning");
    } else {
      if (props.Connect) {
        setIsLoading(true);
        await StackContract.methods
          .claimReward()
          .send({
            from: store.getState().ConnectivityReducer.metamaskAddress,
          })
          .on("transactionHash", function (transactionHash) {
            console.log(transactionHash);
          })
          .on("confirmation", () => {})
          // get New Contract Address
          .then(async () => {
            Swal.fire("Transaction Successful", "", "success");
            StackContract.methods
              .stakeIndex(store.getState().ConnectivityReducer.metamaskAddress)
              .call()
              .then((res) => {
                setTotalStacked(res / Math.pow(10, 18));
                setIsLoading(false);
              });
          })
          .catch((err) => {
            setIsLoading(false);
            Swal.fire("Transaction Failed", "", "error");
          });

        await StackContract.methods
          .stakeIndex(store.getState().ConnectivityReducer.metamaskAddress)
          .call()
          .then(async (res) => {
            setTotalStacked(res);
            let data = 0;
            for (let index = 1; index <= res; index++) {
              data =
                data +
                (await totalRewards(index, StackContract)) / Math.pow(10, 18);
            }
            setStackRewardBalance(data);
          });
      }
    }
  }

  async function handleUnstack() {
    if (
      props.Connect &&
      ValidationDates.CurrentDate <
        ValidationDates.DepositeTime + ValidationDates.Cooling
    ) {
      Swal.fire("Cannot Unstack in cooling period", "", "warning");
    } else {
      if (props.Connect) {
        setIsLoading(true);
        StackContract.methods
          .claimPool()
          .send({
            from: store.getState().ConnectivityReducer.metamaskAddress,
          })
          .on("transactionHash", function (transactionHash) {
            console.log(transactionHash);
          })
          .on("confirmation", () => {})
          // get New Contract Address
          .then(async () => {
            Swal.fire("Transaction Successful", "", "success");
          })
          .catch((err) => {
            setIsLoading(false);
            Swal.fire("Transaction Failed", "", "error");
          });
      }
    }
  }

  async function _HandleConnect() {
    await getAllAccountDetails()
      .then(async (res) => {
        if (res.result !== "") {
          props.setConnect(true);
        }

        console.log(store.getState().ConnectivityReducer.metamaskAddress);

        StackContract.methods
          .stakeIndex(store.getState().ConnectivityReducer.metamaskAddress)
          .call()
          .then((res) => {
            setStackCounter(res);
            console.log(res);
            setTheArray([]);
            for (let index = 1; index <= res; index++) {
              setTheArray((prevArray) => [...prevArray, index]);
            }
          });
      })
      .catch((err) => console.log(err));
  }

  async function stackHandleChanged(e) {
    if (0 < e.target.value) {
      setisApproveDisabled(false);
      setValue(e.target.value);
    } else {
      setisApproveDisabled(true);
      setisStackDisabled(true);
      setValue(0);
    }
  }

  async function isApprove() {
    setisInputDisabled(true);
    setIsLoading(true);
    await isStackPayoutTokenContracted.methods
      .approve(
        await StackContract._address,
        web3_.utils.toWei(isValue.toString(), "ether")
      )
      .send({ from: store.getState().ConnectivityReducer.metamaskAddress })
      .on("transactionHash", function (transactionHash) {
        console.log(transactionHash);
      })
      .on("confirmation", () => {})
      // get New Contract Address

      .then(() => {
        Swal.fire("Transaction Successful", "", "success");
        setisApproveDisabled(true);
        setisStackDisabled(false);
        setIsLoading(false);
      })
      .catch((err) => {
        Swal.fire("Transaction Failed", "", "error");
        setisInputDisabled(false);
        setisApproveDisabled(true);
        setIsLoading(false);
      });
  }

  function isStacked() {
    setIsLoading(true);
    StackContract.methods
      .PoolStake(web3_.utils.toWei(isValue.toString(), "ether"))
      .send({ from: store.getState().ConnectivityReducer.metamaskAddress })
      .on("transactionHash", function (transactionHash) {
        console.log(transactionHash);
      })
      .on("confirmation", () => {})
      // get New Contract Address

      .then(() => {
        Swal.fire("Transaction Successful", "", "success");
        StackContract.methods
          .userTotalStake(store.getState().ConnectivityReducer.metamaskAddress)
          .call()
          .then((res) => {
            console.log(res);
            setStackTotalBalance(res / Math.pow(10, 18));
          });
        StackContract.methods
          .stakeIndex(store.getState().ConnectivityReducer.metamaskAddress)
          .call()
          .then((res) => {
            setStackCounter(res);
            console.log(res);
            setTheArray([]);
            for (let index = 1; index <= res; index++) {
              setTheArray((prevArray) => [...prevArray, index]);
            }
          });
        setisApproveDisabled(false);
        setisStackDisabled(true);
        setisInputDisabled(false);
        setIsLoading(false);
        // StackContract.methods
        //   .users(store.getState().ConnectivityReducer.metamaskAddress)
        //   .call()
        //   .then((res) => {
        //     // setStackTotalBalance(res.total_deposits / Math.pow(10, 18));
        //     setStackBalance(res.poolBal / Math.pow(10, 18));
        //     setIsLoading(false);
        //   });
      })
      .catch((err) => {
        setIsLoading(false);
        // setisInputDisabled(false);
        Swal.fire("Transaction Failed", "", "error");
      });

    document.getElementById("stacking_amt").value = "";
  }

  async function _HandleDisconnect() {
    setStackBalance(0);
    setTotalStacked(0);
    setStackTotalBalance(0);
    setTheArray([]);
    props.setConnect(false);
    store.dispatch({ type: "WALLET_DISCONNECT" });
    // console.log(store.getState().ConnectivityReducer);
    let data = {
      address: store.getState().ConnectivityReducer.metamaskAddress,
      amount: store.getState().ConnectivityReducer.metamaskBalance,
      network: store.getState().ConnectivityReducer.metamaskNetwork,
    };
    localStorage.removeItem("Data", data);
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      window.history.go(1);
    };
  }

  return (
    <>
      {isloading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "89vh",
          }}
        >
          <h3 style={{ color: "#ff832e" }}>Please wait...</h3>
          <Loading />
        </div>
      ) : (
        <div className="container">
          <div
            class="row mb-5 mt-3 paddingclass"
            style={{ justifyContent: "space-between" }}
          >
            <div style={{ minWidth: "-webkit-fill-available" }}>
              <div data-v-cbeecb6c="" data-v-5b46e2aa="" class="pool">
                <div data-v-cbeecb6c="" class="pool__container">
                  <div data-v-cbeecb6c="" class="pool__top">
                    <div data-v-cbeecb6c="" class="pool__ava">
                      <img
                        data-v-cbeecb6c=""
                        src="https://samurai.cyberfi.tech/_nuxt/img/metamafia.72f2449.png"
                        alt="ava"
                      />
                    </div>
                    <div
                      data-v-cbeecb6c=""
                      class="pool__network"
                      style={{ textDecoration: "none" }}
                    >
                      <span className="text-warning">APY {12}%</span>
                    </div>
                    <div data-v-cbeecb6c="" class="pool__network">
                      <img
                        data-v-cbeecb6c=""
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUBAMAAAB/pwA+AAAAGFBMVEUAAAD/xwD/xwD/xwD/zwD/yAD/xgD/xwAOl1etAAAAB3RSTlMAgN8gEM+gZtFyLwAAAHBJREFUCNddj7EJQCEMRCNmADsHsLCVTJDGDQRbV1BQ1//6gwhedTyS3AW2lIEjW49Tc5oD56wHNr+wQEeCMbeg/diWo0OmgmvSYYhJAxmwLWDurH0VO2BZGSiaycgaUEJY+o91vhFvsNS5JZ/q96EPRwgaUSdfEDoAAAAASUVORK5CYII="
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div data-v-cbeecb6c class="pool__scroll">
                  <div data-v-cbeecb6c class="pool__title">
                    Infp 30-Day Staking Pool
                  </div>
                  <div data-v-cbeecb6c class="pool__sub" style={{ opacity: 1 }}>
                    {/* Available Balance:0.000 INFP */}
                    <br />
                    <input
                      id="stacking_amt"
                      type="number"
                      min={0}
                      onChange={stackHandleChanged}
                      style={{ width: "96%", padding: 6, borderRadius: 10 }}
                      placeholder="Enter Stake Amount"
                      disabled={isInputDisabled}
                    />
                    <div
                      className="mr-5"
                      style={{
                        color: "white",
                        display: "flex",
                        margin: "",
                        justifyContent: "space-between",
                      }}
                    >
                      <a
                        href={
                          "https://testnet.bscscan.com/address/" +
                          `${InfinityStackingAddress}`
                        }
                        target="_blank"
                      >
                        <p
                          className="text-white"
                          style={{ fontFamily: "Industry-Medium, serif" }}
                        >
                          View Contract
                        </p>
                      </a>
                      <a
                        href={
                          "https://testnet.bscscan.com/address/" +
                          `${PayoutContractAddress}`
                        }
                        target="_blank"
                      >
                        <p
                          className="text-white mr-4"
                          style={{ fontFamily: "Industry-Medium, serif" }}
                        >
                          See Token Info
                        </p>
                      </a>
                    </div>
                    {/* <div style={{ }}>
                      <p style={{ color: "white", opacity: 1, }}>
                        See Token Info
                      </p>
                    </div> */}
                    <div
                      className="mr-5"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <div
                        data-v-cbeecb6c
                        className="pool__label"
                        style={{ opacity: 1 }}
                      >
                        <h6
                          style={{
                            color: "white",
                            fontFamily: "Industry-Medium, serif",
                          }}
                        >
                          Staked Balance
                        </h6>
                        <p
                          style={{
                            color: "white",
                            fontFamily: "Industry-Medium, serif",
                          }}
                        >
                          {StackTotalBalance} INF
                        </p>
                      </div>{" "}
                      <div
                        data-v-cbeecb6c
                        className="pool__label mr-4"
                        style={{ opacity: 1 }}
                      >
                        <h6
                          style={{
                            color: "white",
                            fontFamily: "Industry-Medium, serif",
                          }}
                        >
                          Total Rewards
                        </h6>
                        <p
                          style={{
                            color: "white",
                            fontFamily: "Industry-Medium, serif",
                          }}
                        >
                          {/* {console.log(StackTotalReward)} */}
                          {parseFloat(stackRewardBalance).toFixed(2)} INF
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexGrow: "grow",
                    width: "96%",
                    alignItems: "end",
                  }}
                >
                  {!props.Connect ? (
                    <button
                      onClick={_HandleConnect}
                      style={{
                        padding: 5,
                        marginBottom: 10,
                        textAlign: "center",
                        borderRadius: 30,
                        background: "#dd6f20",
                        width: "49%",
                        fontFamily: "Industry-Medium, serif",
                      }}
                    >
                      Connect wallet
                    </button>
                  ) : (
                    <button
                      onClick={_HandleDisconnect}
                      style={{
                        padding: 5,
                        marginBottom: 10,
                        textAlign: "center",
                        borderRadius: 30,
                        background: "#dd6f20",
                        width: "49%",
                        fontFamily: "Industry-Medium, serif",
                      }}
                    >
                      Disconnect wallet
                    </button>
                  )}
                  <button
                    onClick={isApprove}
                    disabled={isApproveDisabled}
                    className=""
                    style={{
                      minWidth: "23%",
                      marginBottom: 10,
                      padding: 6,
                      borderRadius: 30,
                      background: "#dd6f20",
                      textAlign: "center",
                      fontFamily: "Industry-Medium, serif",
                      fontSize: 14,
                      opacity: `${!isApproveDisabled ? "1" : "0.8"}`,
                    }}
                  >
                    Approve
                  </button>
                  <button
                    onClick={isStacked}
                    disabled={isStackDisabled}
                    className=""
                    style={{
                      minWidth: "23%",
                      marginBottom: 10,
                      padding: 6,
                      borderRadius: 30,
                      background: "#dd6f20",
                      textAlign: "center",
                      fontFamily: "Industry-Medium, serif",
                      fontSize: 14,
                      opacity: `${!isStackDisabled ? "1" : "0.8"}`,
                    }}
                  >
                    Stake/Staked
                  </button>
                </div>

                <br />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    flexGrow: "grow",
                    width: "96%",
                    alignItems: "end",
                  }}
                >
                  <NavbarDropdown
                    style={{
                      minWidth: "49%",
                      padding: "0px 0px",
                      borderRadius: 30,
                      background: "#dd6f20",
                      textAlign: "center",
                      fontFamily: "Industry-Medium, serif",
                      fontSize: 14,
                    }}
                  >
                    <button
                      className="mx-0"
                      disabled={stackBalance === 0}
                      // onClick={handleUnstack}
                      style={{
                        minWidth: "49%",
                        padding: "6px 0px",
                        borderRadius: 30,
                        background: "#dd6f20",
                        textAlign: "center",
                        fontFamily: "Industry-Medium, serif",
                        fontSize: 14,
                      }}
                    >
                      <DialogComponetStack
                        options={options}
                        StackContract={StackContract}
                        type={"unstack"}
                        setStackTotalBalance={setStackTotalBalance}
                        setStackRewardBalance={setStackRewardBalance}
                        setIsLoading={setIsLoading}
                      />
                    </button>
                    <div
                      style={{
                        display: `${stackBalance === 0 ? "none" : "block"}`,
                      }}
                    >
                      <DropDown>
                        <Table>
                          <tr>
                            <th>Serial no.</th>
                            <th>Stake Amount</th>
                            <th>Stake Date</th>
                          </tr>
                          {stackBalance !== 0 ? (
                            <>
                              <td>1.</td>
                              <td>
                                <button
                                  style={{ color: "#fff", background: "none" }}
                                  onClick={handleUnstack}
                                >
                                  {stackBalance}
                                </button>
                              </td>
                              <button
                                style={{ color: "#fff", background: "none" }}
                                onClick={handleUnstack}
                              >
                                {moment().format("lll")}
                              </button>
                            </>
                          ) : (
                            <p>User not staked yet</p>
                          )}
                        </Table>
                      </DropDown>
                    </div>
                  </NavbarDropdown>

                  <NavbarDropdown
                    style={{
                      minWidth: "49%",
                      padding: "0px 0px",
                      borderRadius: 30,
                      background: "#dd6f20",
                      textAlign: "center",
                      fontFamily: "Industry-Medium, serif",
                      fontSize: 14,
                    }}
                  >
                    <div
                      // disabled={StackTotalReward === 0}
                      style={{
                        minWidth: "49%",
                        padding: 6,
                        borderRadius: 30,
                        background: "#dd6f20",
                        textAlign: "center",
                        fontFamily: "Industry-Medium, serif",
                        fontSize: 14,
                      }}
                      // onClick={handleClaim}
                    >
                      <DialogComponent
                        options={options}
                        StackContract={StackContract}
                        type="stack"
                        setStackTotalBalance={setStackTotalBalance}
                        setStackRewardBalance={setStackRewardBalance}
                        setIsLoading={setIsLoading}
                      />
                    </div>

                    <div
                      style={{
                        display: `${StackTotalReward === 0 ? "none" : "block"}`,
                      }}
                    ></div>
                  </NavbarDropdown>
                </div>
              </div>
              {/* -----bottom content------- */}
              <div className="bottomcard">
                <div
                  data-v-cbeecb6c=""
                  class="pool__cover cover d-flex flex-column"
                >
                  <div data-v-cbeecb6c="" class="cover__item ">
                    <div
                      data-v-cbeecb6c=""
                      class="cover__label"
                      style={{
                        marginLeft: "-103px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    ></div>{" "}
                    {/* <div data-v-cbeecb6c="" class="cover__value">
                    0.000 INFP
                  </div> */}
                  </div>{" "}
                </div>
              </div>
              {/* ----close bottom content----- */}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const DropDown = styled.div`
  display: none;
  position: absolute;
  background-color: #151515;
  min-width: 50px;
  padding: 6px 14px;
  border-radius: 4px;
  margin: 3px 11px;
  z-index: 1;
  width: 96%;
`;

const NavbarDropdown = styled.div`
  position: relative;
  display: inline-block;
  &:hover ${DropDown} {
    display: block;
  }
`;
const Table = styled.table`
  @media (max-width: 769px) {
    font-size: 12px;
  }
`;
